import { Link as InternalLink } from './Link';
import { LinkV2 } from './Link.v2';
import type { LinkV2Component, LinkV2Props } from './Link.v2.types';

type InternalLinkType = typeof InternalLink;

export type LinkInterface = InternalLinkType & {
  v2: LinkV2Component;
};

const Link = InternalLink as LinkInterface;
Link.v2 = LinkV2;

export { LinkButton } from './LinkButton';
export { Link };
export type { LinkV2Props };
